module.exports = __webpack_public_path__ + "img/apple-app-store.325d11c.svg";